import { Injectable } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { CustomFormValidators, DatePickerService } from '@spartacus/storefront';


@Injectable({
  providedIn: 'root',
})
export class CartFormService {
  constructor(protected datePickerService: DatePickerService) { }

  form: FormGroup = new FormGroup({
    ponumber: new FormControl('', [
      Validators.required,
      CustomFormValidators.noSpecialCharacters,
    ]),
    address: new FormControl('', Validators.required),
    nominatedDays: new FormControl('', [
      Validators.required,
      CustomFormValidators.patternValidation((date) =>
        this.datePickerService.isValidFormat(date)
      ),
    ]),
  });
}
